const adjustRows = ($promo, ratio, available_rows, total_gap) => {
  const content_width = $promo.find('.content').width();

  if (window.theme.breakpoints.current === 'mobile') {
    const content_height = (content_width * ratio);

    $promo.find('.grid-promo-block').height(content_height);
  } else {
    const content_height = (content_width * ratio) - total_gap;
    const row_height = content_height / available_rows;
  
    _.each($promo.find('.grid-promo-block'), (block) => {
      $(block).height($(block).data('rows') * row_height);
    });
  }
};

const adjustGridPromos = () => {
  _.each($('.grid-promo'), (promo) => {
    let ratio = 1;
    let available_rows = 12;
    let total_gap = 10;

    if ($(promo).hasClass('layout-3')) {
      total_gap = 20;
    }

    if ($(promo).hasClass('layout-5')) {
      available_rows = 10;
    }

    ratio = $(promo).data('height-ratio');
    total_gap = $(promo).data('column-gap');

    adjustRows($(promo), ratio, available_rows, total_gap);
  });
};

export default () => {
  if (!$('.grid-promo').length) {
    return;
  }

  $(window).on('resize', () => {
    adjustGridPromos();
  });

  return true;
};
